module.exports = __webpack_public_path__ + "img/GALLERY-SWIFT-SPORT-5.8ba44336.jpg";